<template>
  <div class="home">
    <van-nav-bar title="用户登录"/>
    <div class="expertlogin-banner">
      <img src="../assets/expertregisterimg/banner.png">
      <div class="expertlogin">
        <div class="expert-box">
          <div class="expert-box-icon"><i class="icon iconfont icon-shouji"></i></div>
          <div class="expert-box-input">
            <van-field type="number" @input="phoneValue" maxlength='11' v-model="phone" clearable placeholder="请输入手机号码" />
          </div>
        </div>
        <div class="expert-box">
          <div class="expert-box-icon"><i class="icon iconfont icon-yanzhengma"></i></div>
          <div class="expert-box-input">
            <van-field type="number" maxlength='6' v-model="sms" left-icon="icon-shouji" center clearable placeholder="请输入验证码">
              <template #button>
                <van-button size="small" :disabled="isSms" @click="getSms">{{smstitle}}</van-button>
              </template>
            </van-field>
          </div>
        </div>
      </div>
    </div>
    <div class="loginbtn">
      <van-button round size="large" :disabled="phone.length === 11 && sms.length === 6 ? false : true" @click="login">登录</van-button>
    </div>
    <div class="loginlink">
      <p>登录即同意<span @click="agreement">《用户协议》</span>与<span @click="policy">《隐私政策》</span></p>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant'
  import store from '@/store'
  import { wechaturl } from '@/api/path.js'
  import { wxshare } from '@/utils/utils.js'
  import { getSendCode, getZkmsyPhonelogin, tokenlogin, identity } from '@/api/resetApi.js'
  export default {
    name: 'expertregister',
    data() {
      return {
        isLogin: true,
        isSms: true,
        time: 60,
        chatTimer: null,
        smstitle: '获取验证码',
        phone: '',
        sms: '',
        yearValue: '',
        token: '',
        list: [],
        img: 'https://zkjy.oss-cn-beijing.aliyuncs.com/2021/share/expertregister.png',
        title: '立即申请，成为中科名兽医平台共享专家。',
        desc: '诚邀全国畜牧业相关专家，在线提供及时、便捷、高效的专业化服务。',
        wechaturl: wechaturl,
        url: wechaturl+'expertlogin',
      }
    },
    created(){
      // this.getUserType()
      console.log('wxshare',this.url)
      wxshare(this.img,this.title,this.desc,this.url)
    },
    methods: {
      // 判断是否输入手机号
      phoneValue() {
        if (this.phone.length === 11) {
          this.isSms = false
        } else {
          this.isSms = true
        }
      },
      // 用户协议
      agreement() {
        // this.$router.push({
        //   name: 'announcement',
        //   query:{
        //     page: 1
        //   }
        // })
        this.$router.replace('/announcement?page=1')
      },
      // 隐私政策
      policy() {
        // this.$router.push({
        //   name: 'privacypolicy',
        //   query:{
        //     page: 1
        //   }
        // })
        this.$router.replace('/privacypolicy?page=1')
      },
      // 1分钟后开启
      openNum() {
        let that = this
        that.chatTimer = window.setInterval(function () {
          that.time = that.time - 1;
          that.smstitle = '重新发送('+ that.time + "s)";
          that.isSms = true;
          if (that.time == 0) {
            window.clearInterval(that.chatTimer);
            that.smstitle = "获取验证码";
            that.time = 60;
            that.isSms = false;
          }
        }, 1000)
      },
      // 获取验证码
      getSms() {
        let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!this.phone) {
          Toast.fail('请输入手机号');
        } else if (!myreg.test(this.phone)) {
          console.log('phone',this.phone)
          Toast.fail('请输入正确手机号');
        } else {
          this.getSendCode()
        }
      },
      async getSendCode() {
        let data = {
          cuPhone: this.phone,
          cpmType: 1,
          sysCode : "zkmsy",
        }
        const res = await getSendCode(data)
        console.log(res)
        try {
          if (res.data.code == 200) {
            this.openNum()
            Toast.success('验证码发送成功');
          } else {
            Toast.fail(res.data.msg);
          }
        } catch (error) {}
      },
      // 立即登录
      login() {
        let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.phone)) {
          console.log('phone',this.phone)
          Toast.fail('请输入正确手机号');
        } else if (!this.sms) {
          Toast.fail('请输入验证码');
        } else {
          this.getZkmsyPhonelogin()
        }
      },
      async getZkmsyPhonelogin() {
        console.log('this.phone',this.phone)
        console.log('this.sms',this.sms)
        let data = {
          cuPhone: this.phone,
          msgCode: this.sms,
        }
        const res = await getZkmsyPhonelogin(data)
        console.log(res)
        try {
          if (res.data.code == 200) {
            this.token = res.data.data
            localStorage.setItem('uToken', res.data.data)
            this.tokenlogin()
          } else {
            Toast.fail(res.data.msg);
          }
        } catch (error) {}
      },
      // 获取登录信息
      async tokenlogin() {
        let data = {
          syscode: 'zkmsy',
          utoken: this.token,
          accessPort: 'h5',
          reg_form: 'applet'
        }
        const res = await tokenlogin(data)
        console.log(res)
        try {
          if (res.data.code == 1) {
            this.list = res.data.obj[0]
            localStorage.setItem('eToken', res.data.obj[0].token)
            localStorage.setItem('userId', res.data.obj[0].user_id)
            this.$store.state.report.expertToken = res.data.obj[0].token
            this.$store.state.report.expertUserName = res.data.obj[0].user_name
            this.$store.state.report.expertUserId = res.data.obj[0].user_id
            this.identity()
          } else {
            Toast.fail(res.data.msg);
          }
        } catch (error) {}
      },
      // 专家类型
      async identity() {
        const res = await identity()
        console.log(res)
        try {
          if (res.data.code == 200) {
            if (parseInt(res.data.data) == 1) {
              // this.$router.push({
              //   name: 'authentication',
              //   query:{
              //     page: 1
              //   }
              // })
              this.$router.replace('/authentication?page=1')
            } else if (parseInt(res.data.data) == 2) {
              // this.$router.push({
              //   name: 'expertregistersuccess',
              //   query:{
              //     state: 3
              //   }
              // })
              this.$router.replace('/expertregistersuccess?state=3')
            } else if (parseInt(res.data.data) == 3) {
              // this.$router.push({
              //   name: 'expertregistersuccess',
              //   query:{
              //     state: 2
              //   }
              // })
              this.$router.replace('/expertregistersuccess?state=2')
            }
          } else {
            Toast.fail(res.data.msg);
          }
        } catch (error) {}
      },
    },
  }
</script>

<style lang="scss">

  @import "../assets/font/iconfont.css";
  .home {
    max-width: 768px;
    margin: 0 auto;
  }
  .van-nav-bar--fixed {
    position: fixed;
    top: 0;
    left: 50%;
    margin-left: -1.9rem;
    width: 3.8rem;
  }
  .expertlogin-banner {
    position: relative;
    width: 100%;
    height: 3.2rem;
    img {
      width: 100%;
      height: 3.2rem;
    }
    .expertlogin {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 3.4rem;
      height: 1.3rem;
      margin-left: -1.7rem;
      background: #fff;
      border-top-right-radius: 0.08rem;
      border-top-left-radius: 0.08rem;
      overflow: hidden;
      font-size: 0;
      text-align: left;
      .expert-box {
        display: flex;
        margin: 0 0.16rem;
        border-bottom: 0.01rem solid #f5f5f5;
        .expert-box-icon {
          flex: 0 0 0.2rem;
          align-self: center;
          .icon {
            display: inline-block;
            margin-top: 0.15rem;
            color: #e1e1e1;
          }
        }
        .expert-box-input {
          flex: 1;
          align-self: center;
          .van-cell {
            padding: 0.25rem 0 0.1rem;
          }
          .van-button--default {
            background-color: #127BE4;
            border-radius: 0.04rem;
            color: #fff;
          }
        }
      }
    }
  }
  .loginbtn {
    font-size: 0;
    padding: 0.5rem 0.2rem 0;
    .van-button--default {
      background-color: #127BE4;
      color: #fff;
    }
  }
  .loginlink {
    padding-top: 0.2rem;
    text-align: center;
    p {
      font-size: 0.14rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #666666;
      span {
        font-weight: bold;
        color: #127BE4;
      }
    }
  }
</style>